import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import './Home.css';

function Home() {
  const { language } = useLanguage();
  const [cartaActiva, setCartaActiva] = useState(null);

  const textos = {
    intro: {
      es: 'Bienvenidos a nuestra casa de sabores tradicionales. Descubre platos autenticos de la cocina china, elaborados con ingredientes frescos y recetas ancestrales.',
      en: 'Welcome to our house of traditional flavors. Discover authentic Chinese dishes made with fresh ingredients and ancestral recipes.',
      zh: '欢迎来到我们的传统风味之家。品尝用新鲜食材和祖传配方制作的地道中餐。',
    },
    takeaway: {
      es: 'Puedes recoger la comida en el local.',
      en: 'Takeaway available every day.',
      zh: '支持提前点餐，到店自取',
    },
    menuTitle: {
      es: 'Nuestra carta',
      en: 'Our menu',
      zh: '我们的菜单',
    },
    menuText: {
      es: 'Consulta la carta',
      en: 'View menu',
      zh: '请查看下方菜单',
    },
    close: {
      es: 'Cerrar',
      en: 'Close',
      zh: '关闭',
    },
  };

  const cartas = [
    { src: '/carta01.jpeg', alt: 'Carta actual 1' },
    { src: '/carta02.jpeg', alt: 'Carta actual 2' },
  ];

  return (
    <div className="home-page">
      <div className="App home-shell">
        <header className="hero-panel">
          <div className="hero-copy">
            <span className="hero-kicker">Restaurante</span>
            <h1 className="hero-title">Jiǎo Yǒu Xǐ</h1>
            <p className="hero-title-zh">饺有喜</p>
            <p className="hero-intro">{textos.intro[language]}</p>
            <p className="hero-takeaway">{textos.takeaway[language]}</p>
          </div>

          <div className="hero-image-wrap">
            <img src="/rest-chino01.png" alt="Imagen del restaurante" className="hero-image" />
          </div>
        </header>

        {/*
        Bloque anterior de carta dinamica con filtros y mosaico de platos
        desactivado temporalmente hasta que evolucione la carta del restaurante.
        */}

        <section className="menu-intro-panel">
          <h2 className="menu-title">{textos.menuTitle[language]}</h2>
          <p className="menu-text">{textos.menuText[language]}</p>
        </section>

        <section className="menu-gallery">
          {cartas.map((carta, index) => (
            <article
              key={carta.src}
              className="menu-sheet"
              onClick={() => setCartaActiva(carta)}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  setCartaActiva(carta);
                }
              }}
            >
              <div className="menu-sheet-image-wrap">
                <img
                  src={carta.src}
                  alt={carta.alt}
                  className="menu-sheet-image"
                />
              </div>
              <p className="menu-sheet-label">
                {language === 'es' && `Carta ${index + 1}`}
                {language === 'en' && `Menu ${index + 1}`}
                {language === 'zh' && `菜单 ${index + 1}`}
              </p>
            </article>
          ))}
        </section>
      </div>

      {cartaActiva && (
        <div className="menu-lightbox" onClick={() => setCartaActiva(null)}>
          <button
            className="menu-lightbox-close"
            onClick={() => setCartaActiva(null)}
            aria-label={textos.close[language]}
          >
            ×
          </button>
          <div
            className="menu-lightbox-content"
            onClick={(event) => event.stopPropagation()}
          >
            <img
              src={cartaActiva.src}
              alt={cartaActiva.alt}
              className="menu-lightbox-image"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;
